import type { FC } from 'react';
import type { SxProps } from '@mui/system';
import type { ButtonProps } from '@mui/material';

import { BaseBtn } from './BaseBtn';

interface Props extends ButtonProps {
  loading?: boolean;
  btnColor?: string;
  sx?: SxProps;
}

export const MobileButton: FC<Props> = ({ sx = {}, ...props }) => {
  return (
    <BaseBtn
      sx={{
        borderRadius: '0.5rem', // 8px
        width: '100%',
        height: '3rem', // 48px
        mt: '1rem', // 16px
        ...sx,
      }}
      {...props}
    />
  );
};
